import { HttpClient } from '@angular/common/http';
import { Component, Renderer2 } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { User } from './core/User';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  onChangeLanguage: Function;

  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private translate: TranslateService,
  ) {
    //translate.setDefaultLang('en-ca');
    User.setCurrentCulture(this.translate, User.getCurrentCulture(this.http));
    this.onChangeLanguage = renderer.listen('document', 'languageChanged', (event) => {
      // djb:i18n-language change triggered by Kentico
      var newLang: string = event.detail;
      User.setCurrentCulture(this.translate, newLang);
      var name = "doNothing";
      if (window.location.href.toLowerCase().includes("/package-builder/")) {
        name = "savePackage";
      } else {
        // djb:note-would prefer to avoid redirect but Kentico menu becomes out of sync with angular app
        name = "refreshKentico";
      }
      User.dispatchEvent(name, `app.onChangeLanguage[${newLang}] Event: ${name}`);
    });
  }
}
